import SolitaireState from "./context/SolitaireState";


import Navbar from "./components/layout/Navbar";
import ScoreBoard from "./components/game/ScoreBoard";

import Home from "./components/pages/Home";



import "./css/App.css";
import { useEffect } from "react";

function App() {

  useEffect(() => {
    const initializeSDK = async () => {
      let attempts = 0;

      // Ожидаем, пока SDK загрузится
      while (!window.YaGames && attempts < 10) {
        console.log("Ожидание загрузки YaGames SDK...");
        await new Promise((resolve) => setTimeout(resolve, 500));
        attempts += 1;
      }

      if (window.YaGames) {
        try {
          const ysdk = await window.YaGames.init(); // Инициализация SDK
          window.ysdk = ysdk;
          console.log("Yandex SDK успешно инициализирован");
         
         

          // Автоматически показываем рекламу при старте игры
          ysdk.adv.showFullscreenAdv({
            callbacks: {
              onClose: function (wasShown) {
                if (wasShown) {
                  console.log("Реклама была показана и закрыта, запускаем игру.");
                } else {
                  console.warn("Реклама была пропущена, но игра запускается.");
                }
        
                // Инициализация игры
                // getRandomQuestions();
                // loadQuestion();
        
                // Уведомляем, что игра готова
                 ysdk.features.LoadingAPI?.ready();
              },
              onError: function (error) {
                console.error("Ошибка при показе рекламы:", error);
                // При ошибке все равно запускаем игру
                // getRandomQuestions();
                // loadQuestion();
                 ysdk.features.LoadingAPI?.ready();
              },
            },
          });
        } catch (err) {
          console.error("Ошибка при инициализации Yandex SDK:", err);
        }
      } else {
        console.error("YaGames SDK недоступен. Убедитесь, что он загружается.");
      }
    };

    initializeSDK(); // Инициализация SDK и показ рекламы при старте
  }, []);




  return (
    <SolitaireState>
      
        <div className="App">
          <header className="header">
            <Navbar />
            <ScoreBoard />
          </header>
          
          <Home/>
        </div>
      
    </SolitaireState>
  );
}

export default App;
